// extracted by mini-css-extract-plugin
module.exports = {"options":"query-error_options__sUMXT"};